export default function calcExp(
  startDate: string,
  endDate: string,
  empAtual: number
): string {
  const start = new Date(startDate);
  let end = new Date(endDate);

  if (empAtual == 1) {
    end = new Date();
  }

  // Verificar se as datas fornecidas são válidas
  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return "Datas inválidas";
  }

  let yearDifference = end.getFullYear() - start.getFullYear();
  let monthDifference = end.getMonth() - start.getMonth();

  if (monthDifference < 0) {
    yearDifference--;
    monthDifference += 12;
  }

  let experience: string;

  if (yearDifference === 0 && monthDifference === 0) {
    experience = "1 mês";
  } else {
    let yearString = yearDifference === 1 ? "ano" : "anos";
    let monthString = monthDifference === 1 ? "mês" : "meses";

    if (yearDifference === 0) {
      experience = `${monthDifference} ${monthString}`;
    } else if (monthDifference === 0) {
      experience = `${yearDifference} ${yearString}`;
    } else {
      experience = `${yearDifference} ${yearString} e ${monthDifference} ${monthString}`;
    }
  }

  return experience;
}
